/* tslint:disable: ordered-imports*/
import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

/* Modules */
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { IconsModule } from '@modules/icons/icons.module';
import { PrimeNgModule } from './prime-ng/prime-ng.module';

const modules = [IconsModule, NgbModule, PrimeNgModule];

/* Containers */
import * as appCommonContainers from './containers';

/* Components */
import * as appCommonComponents from './components';

/* Directives */
import * as appCommonDirectives from './directives';

/* Guards */
import * as appCommonGuards from './guards';

/* Services */
import * as appCommonServices from './services';
import * as authServices from '@modules/auth/services';
import { MeteringFarmSingleSelectComponent } from 'app/components/metering-farm-single-select/metering-farm-single-select.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { JobStatusComponent } from '@app/components/job-status/job-status.component';
import { TextFormatPipe } from '@app/pipe/text-format.pipe';
import { CapitalizeFirstPipe } from '@app/pipe/capitalize-first.pipe';




@NgModule({
    imports: [CommonModule, RouterModule, ...modules , NgSelectModule],
    declarations: [
        ...appCommonContainers.containers,
        ...appCommonComponents.components,
        ...appCommonDirectives.directives,
        MeteringFarmSingleSelectComponent,
        JobStatusComponent,
        TextFormatPipe,
        CapitalizeFirstPipe
    ],
    exports: [
        ...appCommonContainers.containers,
        ...appCommonComponents.components,
        ...appCommonDirectives.directives,
        ...modules,
        MeteringFarmSingleSelectComponent,
        JobStatusComponent,
        TextFormatPipe,
        CapitalizeFirstPipe
    ],
    providers: [CapitalizeFirstPipe],
})
export class AppCommonModule {
    static forRoot(): ModuleWithProviders<AppCommonModule> {
        return {
            ngModule: AppCommonModule,
            providers: [
                ...appCommonServices.services,
                ...authServices.services,
                ...appCommonGuards.guards,
                { provide: 'window', useValue: window },
            ],
        };
    }
}
